import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { Box } from "@mui/material";
import { FC } from "react";

interface IWSIBOntarioCodeSetupInfoFieldsPanel {
	codesDDL:any[];
 }
export const WSIBOntarioCodeSetupInfoFieldsPanel: FC<
	IWSIBOntarioCodeSetupInfoFieldsPanel
> = ({ codesDDL }) => {
	return (
		<Box>
			<EnhancedDropDownRHFWithLabel
				testId={"code-setup"}
				selectName={"code"}
				items={codesDDL ?? []}
				label={"Select Code"}
				showEmpty
			/>
		</Box>
	);
};
